import { BackOfficeOrderControllerApiFactory } from '@ce-openapi/order-reporting-service-ts-axios-client';
import { axios } from '@pukka/auth';
import { MOKA_GOAUTH_SERVICE } from '@pukka/common/constants';

import { OrdersModel } from '../models';

const ORDER_REPORTING_SERVICE = `${MOKA_GOAUTH_SERVICE}/order-reporting`;

const ORDERS_V1_URL = `${ORDER_REPORTING_SERVICE}/backoffice/v1/orders`;

const ORDERS_V3_URL = `${ORDER_REPORTING_SERVICE}/v3/orders`;

type OrderRequest = {
  outletIds: number[];
  startTime: string; // e.g 2023-01-01T00:00:00
  endTime: string; // e.g. 2023-12-31T23:59:59
  keyword?: string;
  nextCursor?: string;
};

// Success Transaction List
async function getOrders({ outletIds, startTime, endTime, keyword, nextCursor }: OrderRequest): Promise<OrdersModel.Response> {
  const { data } = await axios.get(ORDERS_V1_URL, {
    params: {
      start_time: startTime,
      end_time: endTime,
      keyword,
      cursor: nextCursor,
    },
    headers: { outlet_id: outletIds.length > 1 ? '' : outletIds[0] },
  });

  return data;
}

const orderApi = BackOfficeOrderControllerApiFactory(
  undefined,
  ORDER_REPORTING_SERVICE,
  axios as Parameters<typeof BackOfficeOrderControllerApiFactory>[2],
);

// TODO: Update the OpenAPI spec
const getOrderDetail = async (token: string) =>
  orderApi.backofficeV1OrdersIdGet(token).then((res) => res.data as unknown as OrdersModel.OrderDetail);

// NOTE: currently not used
// async function getOrderDetailV3(token: string): Promise<OrdersV3Model.InvoiceDetail> {
//   const { data } = await axios.get(`${ORDERS_V3_URL}/${token}`);

//   return data;
// }

export { ORDER_REPORTING_SERVICE, ORDERS_V1_URL, ORDERS_V3_URL, getOrders, getOrderDetail };
